
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-36757534&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ShopOrderDetailRecord.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/shop-order-detail-record.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-36757534!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/shop-order-detail-record.pug"),
  /* scopeId */
  "data-v-36757534",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ShopOrderDetailRecord.vue
// module id = 132
// module chunks = 1